import { render, staticRenderFns } from "./PipeDiameterTab.vue?vue&type=template&id=56a2b47e&scoped=true"
import script from "./PipeDiameterTab.vue?vue&type=script&lang=ts"
export * from "./PipeDiameterTab.vue?vue&type=script&lang=ts"
import style0 from "./PipeDiameterTab.vue?vue&type=style&index=0&id=56a2b47e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a2b47e",
  null
  
)

export default component.exports